import { render, staticRenderFns } from "./StudentTrainAnswerDetail.vue?vue&type=template&id=5975343e&scoped=true&"
import script from "./StudentTrainAnswerDetail.vue?vue&type=script&lang=js&"
export * from "./StudentTrainAnswerDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudentTrainAnswerDetail.vue?vue&type=style&index=0&id=5975343e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5975343e",
  null
  
)

export default component.exports